import {postRequest} from '../libs/AxiosService.util';

export async function serviceCreateAppUsers(params) {
    return await postRequest('users/create', params);
}

export async function serviceUpdateAppUsers(params) {
    return await postRequest('users/update', params);
}

export async function serviceDeleteAppUsers(params) {
    return await postRequest('users/delete', params);
}

export async function serviceGetAppUsers (params) {
    return await postRequest('users/app', params);
}

export async function serviceGetAppUsersList (params) {
    return await postRequest('users/app', params);
}

export async function serviceGetAppUsersDetails (params) {
    
    return await postRequest('users/detail', params);
}
export async function serviceExportAppUsersList (params) {
    
    return await postRequest('users/app/export', params);
}

